<template>
    <el-container>
        <el-header>
            <h1>vivo点击检测</h1>
        </el-header>
        <el-main>

             
            <el-form ref="form" :model="form" :rules="rules">
                <!-- 动态渲染价格区间 -->
                <div v-for="(range, index) in form.ranges" :key="index"
                    style="display: flex; align-items: center; margin-bottom: 10px;">
                    <el-form-item :prop="`ranges[${index}].min`" :rules="rules.min">
                        <el-input v-model="range.min" placeholder="最小值" style="width: 100px;"
                            @change="handleMinChange(index)" />
                    </el-form-item>
                    <el-form-item>~</el-form-item>
                    <el-form-item :prop="`ranges[${index}].max`" :rules="rules.max">
                        <el-input v-model="range.max" placeholder="最大值" style="width: 100px;"
                            @change="handleMaxChange(index)" />
                    </el-form-item>
                    <!-- 只在最后一组显示添加按钮，并根据条件禁用 -->
                    <el-form-item v-if="index === form.ranges.length - 1">
                        <el-button type="text" icon="el-icon-plus" @click="addPriceRange(index)"
                            :disabled="!isCurrentRangeValid(range)" />
                    </el-form-item>
                </div>
            </el-form>
        </el-main>
    </el-container>
</template>
  
<script>
export default {
    data() {
        return {
            form: {
                ranges: [{ min: '', max: '' }] // 初始一组空区间
            },
            rules: {
                min: [
                    { required: true, message: '请输入最小值', trigger: 'blur' },
                    { validator: this.validateNumber, trigger: 'blur' },
                    { validator: this.validateMin, trigger: 'blur' }
                ],
                max: [
                    { required: true, message: '请输入最大值', trigger: 'blur' },
                    { validator: this.validateNumber, trigger: 'blur' },
                    { validator: this.validateMax, trigger: 'blur' }
                ]
            }
        };
    },
    methods: {
        // 检查当前区间是否有效（min和max均有值且min < max）
        isCurrentRangeValid(range) {
            return (
                range.min !== '' &&
                range.max !== '' &&
                Number(range.min) < Number(range.max)
            );
        },

        // 新增区间
        addPriceRange(index) {
            const currentRange = this.form.ranges[index];
            if (!this.isCurrentRangeValid(currentRange)) {
                this.$message.warning('请正确填写当前区间的最小值和最大值！');
                return;
            }
            this.form.ranges.push({ min: '', max: '' }); // 新增一组空区间
        },

        // 校验输入是否为数字
        validateNumber(rule, value, callback) {
            if (!value || isNaN(Number(value))) {
                callback(new Error('必须输入数字'));
            } else {
                callback();
            }
        },

        validateMin(rule, value, callback) {
            const matches = rule.field.match(/\[(\d+)\]/); // 匹配 [index]
            const index = matches ? parseInt(matches[1]) : 0; // 默认 0
            const one = Number(value);
            const max = this.form.ranges[index] ? Number(this.form.ranges[index].max) : null;
            if (!max || one < max) {
                callback();
            } else {
                callback(new Error('输入值不得大于最大阈值'));
            }
        },
        validateMax(rule, value, callback) {
            const matches = rule.field.match(/\[(\d+)\]/);
            const index = matches ? parseInt(matches[1]) : 0;
            const one = Number(value);
            const min = this.form.ranges[index] ? Number(this.form.ranges[index].min) : null;
            if (!min || one > min) {
                callback();
            } else {
                callback(new Error('输入值不得小于最小阈值'));
            }
        },

        // 最小值变化时触发校验
        handleMinChange(index) {
            this.$refs.form.validateField(`ranges[${index}].max`);
        },

        // 最大值变化时触发校验
        handleMaxChange(index) {
            this.$refs.form.validateField(`ranges[${index}].min`);
        }
    }
};
</script>


// WEBPACK FOOTER //
// src/components/login/vivodjjc.vue